<template>
  <span></span>
</template>
<script>
import Swal from "sweetalert2";
import { mapState } from "vuex";

export default {
  name: "Flash",
  computed: {
    ...mapState(["flash"]),
  },
  mounted() {
    let store = this.$store;
    try {
      Swal.fire({
        title: this.flash.title,
        html: this.flash.message,
        type: this.flash.type,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onClose: function () {
          store.commit("SET_FLASH", false);
        },
      });
    } catch (err) {
      console.log(err);
    }
  },
};
</script>
